import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'

import { StoreContext } from 'store/context'
import { createColumns } from './columns.description'
import SponsorsOverviewComponent from './component'

// Storage key for persisting filter state (must match the key in filters/container.js)
const MARKETING_FILTER_KEY = 'sponsors_marketing_promotion_filter';

// Helper to get persisted filter value
const getPersistedFilterValue = () => {
  try {
    const saved = localStorage.getItem(MARKETING_FILTER_KEY);
    if (saved === 'true') return true;
    if (saved === 'false') return false;
  } catch (e) {
    // Silently handle localStorage errors
  }
  return undefined;
};

// Helper to extract marketingPromotion filter value from filtered state
const extractMarketingPromotionFromState = (tableState) => {
  if (!tableState.filtered?.length) return undefined;

  // Find the filtered item that contains our query parameters
  const queryItem = tableState.filtered.find(item => item.id === 'all');
  if (!queryItem?.value) return undefined;

  // If we have a structured query object
  if (typeof queryItem.value === 'object' && queryItem.value.marketingPromotion !== undefined) {
    return queryItem.value.marketingPromotion;
  }

  return undefined;
};

export const SponsorsOverview = combine(
  withTableController({ id: 'sponsors-table' }),
  withContext(
    'adminSponsorsService',
    ServicesContext,
    ({ adminSponsorsService }) => adminSponsorsService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withCallbacks(
    {
      loadSponsors:
        ({ adminSponsorsService }) =>
          (tableState, _table, query) => {
            // Create a clean query object
            const queryParams = {
              page: tableState.page,
              size: tableState.pageSize,
              sort: 'id,desc',
            };

            // Extract filter values from the query (new filters from dropdown)
            const newQuery = query || {};

            // Get the filter from localStorage
            const persistedFilter = getPersistedFilterValue();

            // Add fullName if present
            if (newQuery.sponsorsName) {
              queryParams.fullName = newQuery.sponsorsName;
            }

            // Priority hierarchy for marketingPromotion value:
            // 1. Dropdown selection directly in query
            if (newQuery.marketingPromotion === true || newQuery.marketingPromotion === false) {
              queryParams.marketingPromotion = newQuery.marketingPromotion;
            }
            // 2. Persisted filter value (if no explicit selection in current query)
            else if (persistedFilter !== undefined) {
              queryParams.marketingPromotion = persistedFilter;
            }

            return adminSponsorsService.querySponsors(queryParams);
          },

      onSearch:
        ({ table }) =>
          (query) => {
            table.search(query);
          },
    },
    []
  )
)(SponsorsOverviewComponent)
